import { render, staticRenderFns } from "./CardLabelForm.vue?vue&type=template&id=0d8d9b92&"
import script from "./CardLabelForm.vue?vue&type=script&lang=js&"
export * from "./CardLabelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports